var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127;}\n\t.st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stroke",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 38,
    y1: 44,
    x2: 38,
    y2: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 14,
    y1: 44,
    x2: 14,
    y2: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,44H7c-1.1,0-2-0.9-2-2V16c0-1.1,0.9-2,2-2h38c1.1,0,2,0.9,2,2v26C47,43.1,46.1,44,45,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M21,14v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "filled"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,13h-6v32h6c1.6543,0,3-1.3457,3-3V16C48,14.3457,46.6543,13,45,13z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 22,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,11v-1c0-1.6543-1.3457-3-3-3h-6c-1.6543,0-3,1.3457-3,3v1h2v-1c0-0.5513,0.4482-1,1-1h6c0.5518,0,1,0.4487,1,1v1H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,16v26c0,1.6543,1.3457,3,3,3h6V13H7C5.3457,13,4,14.3457,4,16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.e40548c310b6eb5341d47310234db95c.svg";
export { ForwardRef as ReactComponent };